import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Customer Container
const CustomerContainer = () => import("@/containers/CustomerContainer");

//Login
const Login = () => import("@/views/frontend/Login");

//ForgotPassword
const UserForgotPassword = () => import("@/views/frontend/ForgotPassword");

//Logout
const Logout = () => import("@/components/auth/Logout");

// Views
const Dashboard = () => import("@/views/Dashboard");

// Users
const Users = () => import("@/views/backend/user/Users");
const UserCreate = () => import("@/views/backend/user/UserCreate");
const UserResetPassword = () => import("@/views/backend/user/UserResetPassword");
const UserProfile = () => import("@/views/backend/user/UserProfile");


//Roles
const Roles = () => import("@/views/backend/role/Roles");
const RoleCreate = () => import("@/views/backend/role/RoleCreate");

// Logs
const Logs = () => import("@/views/backend/Logs");

// Views - Pages (TO:DO - DELETE)
const Page404 = () => import("@/views/pages/Page404");
const AccessDenied = () => import("@/views/pages/AccessDenied");
const PublicLinkExpired = () => import("@/views/pages/PublicLinkExpired");
const Page500 = () => import("@/views/pages/Page500");
const Register = () => import("@/views/pages/Register");

//ActivityLog
const ActivityLog = () => import("@/views/backend/ActivityLog");
const ProposalCreate = () => import("@/views/backend/proposal/ProposalCreate");

const ProposalWizard = () => import("@/views/backend/proposal/ProposalWizard");

const ProposalWizardCustomer = () => import("@/views/backend/proposal/ProposalWizardCustomer");

const Proposals = () => import("@/views/backend/proposal/Proposals");

const CustomerProposals = () => import("@/views/backend/proposal/CustomerProposals");

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: "/",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "/",
          name: "Login",
          component: Login,
        },
        {
          path: "/login",
          name: "Login",
          component: Login,
        },
        {
          path: "forgot-password",
          name: "Forgot Password",
          component: UserForgotPassword,
        },
        {
          path: "logout",
          name: "Logout",
          component: Logout,
        },
      ],
    },
    {
      path: "/",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            label: "Dashboard",
            requiresAuth: true,
            permission: "Dashboard",
          },
        },
        {
          path: "/proposal",
          redirect: "/proposal/list",
          meta: { label: "Proposal" },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "create",
              meta: {
                label: "Create Proposal",
                requiresAuth: true,
                permission: "Proposal_Create"
              },
              name: "ProposalCreate",
              component: ProposalCreate,
            },
            {
              path: "edit_proposal",
              meta: {
                label: "Edit Proposal",
              },
              name: "ProposalEdit",
              component: ProposalCreate,
            },
            {
              path: "wizard",
              meta: {
                label: "Proposal Wizard",
                requiresAuth: true,
                permission: "Proposal_Create"
              },
              name: "ProposalWizard",
              component: ProposalWizard,
            },
            {
              path: "list",
              meta: {
                label: "Issued Proposal",
                requiresAuth: true,
                permission: "Proposal_List",
              },
              name: "ProposalList",
              component: Proposals,
            }
          ],
        },
        {
          path: "/users",
          meta: { label: "User Management" },
          name: "User Management",
          component: {
            render(c) {
              return c("router-view");
            },
          },

          children: [
            {
              path: "/users",
              meta: { label: "User Accounts" },
              component: {
                render(c) {
                  return c("router-view");
                },
              },

              children: [
                {
                  path: "",
                  component: Users,
                  meta: {
                    requiresAuth: true,
                    permission: "Create_user",
                  },
                },
                {
                  path: "create",
                  meta: {
                    label: "Create",
                    requiresAuth: true,
                    permission: "Create_user",
                  },
                  name: "UserCreate",
                  component: UserCreate,
                },
                {
                  path: "edit/:user_id",
                  meta: {
                    label: "Edit",
                    requiresAuth: true,
                    permission: "Edit_user",
                  },
                  name: "UserEdit",
                  component: UserCreate,
                },
                {
                  path: ":id",
                  meta: {
                    label: "View",
                    requiresAuth: true,
                    permission: "View_user",
                  },
                  name: "User",
                  component: UserCreate,
                },
                {
                  path: "reset-password/:user_id",
                  meta: {
                    label: "Reset Password",
                    requiresAuth: true,
                    permission: "Reset_Password_Other",
                  },
                  name: "ResetPassword",
                  component: UserResetPassword,
                },
                {
                  path: "user-profile",
                  meta: {
                    label: "Profile",
                    requiresAuth: true,
                    permission: "Reset_Password_Own",
                  },
                  name: "UsersProfile",
                  component: UserProfile,
                },
              ],
            },

            {
              path: "/roles",
              meta: { label: "User Roles" },
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: Roles,
                },
                {
                  path: "create",
                  meta: {
                    label: "Create",
                    requiresAuth: true,
                    permission: "Create_role",
                  },
                  name: "RoleCreate",
                  component: RoleCreate,
                },

                {
                  path: "edit/:role_id",
                  meta: {
                    label: "Edit",
                    requiresAuth: true,
                    permission: "Edit_role",
                  },
                  name: "RoleEdit",
                  component: RoleCreate,
                },
              ],
            },

            /*
             */
          ],
        },
        {
          path: "/user",
          meta: { label: "User" },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "user-profile",
              meta: {
                label: "User Profile",
                requiresAuth: true,
                permission: "Reset_Password_Own",
              },
              name: "UserProfile",
              component: UserProfile,
            },
          ],
        },
        {
          path: "/activity_log",
          name: "AuditTrail",
          meta: {
            requiresAuth: true,
            permission: "View_Audit_Trail",
          },
          component: ActivityLog,
        },
        {
          path: "/pages",
          redirect: "/pages/404",
          name: "Pages",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "404",
              name: "Page404",
              component: Page404,
            },
            {
              path: "access_denied",
              name: "AccessDenied",
              component: AccessDenied,
            },
            {
              path: "500",
              name: "Page500",
              component: Page500,
            },
            {
              path: "login",
              name: "Login1",
              component: Login,
            },
            {
              path: "register",
              name: "Register",
              component: Register,
            },
          ],
        },

      ],
    },

    {
      path: "/",
      component: CustomerContainer,
      children: [
        {
          path: "/proposal",
          redirect: "/proposal/customer_list",
          meta: { label: "Proposal" },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "customer_list",
              meta: {
                label: "Issued Proposal",
              },
              name: "ProposalListCustomer",
              component: CustomerProposals,
            },
            {
              path: "edit_proposal_customer",
              meta: {
                label: "Edit Proposal",
              },
              name: "ProposalEditCustomer",
              component: ProposalCreate,
            },
            {
              path: "customer_wizard",
              meta: {
                label: "Proposal Wizard",
                requiresAuth: false,
                permission: "Proposal_Create"
              },
              name: "ProposalWizardCustomer",
              component: ProposalWizardCustomer,
            },
            {
              path: "access_denied",
              name: "PublicAccessDenied",
              component: AccessDenied,
            },
            {
              path: "link_expired",
              name: "PublicLinkExpired",
              component: PublicLinkExpired,
            },
          ],
        },
      ],
    },
  ];
}

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});
